/**
 * Données versionnées du pilotage (referentiel-metier.md §1.6) : libellés et ordre des statuts du Trello (STA-01 à STA-09),
 * nature des blocages. Ces valeurs seront servies par la table `statut_dossier` quand RFC-L51-001 sera appliquée ; en
 * attendant, elles vivent ici, datées, et jamais dans la logique. Un libellé servi avec le dossier prévaut sur celui-ci.
 */
export const REFERENTIEL_PILOTAGE = {
  version: '2026-10-17',
  statuts: [
    { code: 'STA-01', libelle: 'Urgences' },
    { code: 'STA-02', libelle: 'À l’étude' },
    { code: 'STA-03', libelle: 'À ouvrir' },
    { code: 'STA-04', libelle: 'En cours' },
    { code: 'STA-05', libelle: 'À travailler' },
    { code: 'STA-06', libelle: 'À compenser' },
    { code: 'STA-07', libelle: 'En attente' },
    { code: 'STA-08', libelle: 'Terminé' },
    { code: 'STA-09', libelle: 'Compte rendu à faire' },
  ] as readonly { code: string; libelle: string }[],
  natures: { genealogie: 'généalogie', titres: 'titres', paiement: 'paiement' } as Readonly<Record<string, string>>,
  codeCompteRendu: 'STA-09',
} as const;
